import { BaseDBTModel } from '/@/modules/core/app/models/abstracts/BaseDBTModel';
import { PredefinedCountry } from '/@/modules/predefined/enums/PredefinedCountry';
import { ProductKey } from '@/modules/estate/enums/ProductKey';
import { StripeCoupon } from '@/modules/billing/models/stripe/StripeCoupon';
import { PointItem } from '@/modules/core/ui/models/PointItem';
import { PointItemCollection } from '@/modules/core/ui/models/PointItemCollection';

export class HubSpotProduct extends BaseDBTModel {
  id?: string;

  propertyHsSku?: string;

  propertyPrice?: number;

  propertyDescription?: string;

  propertyProductDescription?: string;

  propertyHsPriceCad?: number;

  propertyHsPriceUsd?: number;

  propertyHsObjectId?: string;

  propertyHsCostOfGoodsSold?: string;

  propertyName?: string;

  propertyRecurringbillingfrequency?: string;

  propertyPurchaseTerm?: string;

  propertyHsImages?: string;

  propertyStripeId?: string;

  propertyStripeUsId?: string;

  propertyXeroAccountId?: number;

  propertyXeroProductId?: string;

  propertyProductInclusions?: string;

  propertyIsCoupon?: boolean;

  propertyPercentageDiscountOff?: number;

  propertyAmountDiscountOff?: number;

  propertyHsUrl?: string;

  propertyCurrency?: number;

  propertyProductkey?: ProductKey;

  propertyJurisdiction?: string;

  propertyCountry?: string;

  isDeleted?: boolean;

  constructor(model: Partial<HubSpotProduct> = {}) {
    super(model);

    this.id = model.id;
    this.propertyHsSku = model.propertyHsSku;
    this.propertyPrice = model.propertyPrice;
    this.propertyDescription = model.propertyDescription;
    this.propertyProductDescription = model.propertyProductDescription;
    this.propertyHsPriceCad = model.propertyHsPriceCad;
    this.propertyHsPriceUsd = model.propertyHsPriceUsd;
    this.propertyHsObjectId = model.propertyHsObjectId;
    this.propertyHsCostOfGoodsSold = model.propertyHsCostOfGoodsSold;
    this.propertyName = model.propertyName;
    this.propertyRecurringbillingfrequency = model.propertyRecurringbillingfrequency;
    this.propertyPurchaseTerm = model.propertyPurchaseTerm;
    this.propertyHsImages = model.propertyHsImages;
    this.propertyStripeId = model.propertyStripeId;
    this.propertyStripeUsId = model.propertyStripeUsId;
    this.propertyXeroAccountId = model.propertyXeroAccountId;
    this.propertyXeroProductId = model.propertyXeroProductId;
    this.propertyProductInclusions = model.propertyProductInclusions;
    this.propertyIsCoupon = model.propertyIsCoupon;
    this.propertyPercentageDiscountOff = model.propertyPercentageDiscountOff;
    this.propertyAmountDiscountOff = model.propertyAmountDiscountOff;
    this.propertyHsUrl = model.propertyHsUrl;
    this.propertyCurrency = model.propertyCurrency;
    this.propertyProductkey = model.propertyProductkey;
    this.propertyJurisdiction = model.propertyJurisdiction;
    this.propertyCountry = model.propertyCountry;
    this.isDeleted = model.isDeleted;
  }

  get productInclusions(): PointItem[] | undefined {
    return PointItemCollection.mapFromText(this.propertyProductInclusions).items;
  }

  getStripeId(countryId: number): string | undefined {
    if (countryId === PredefinedCountry.UNITED_STATES.id) {
      return this.propertyStripeUsId;
    }

    return this.propertyStripeId;
  }

  getDiscountedPrice(coupon?: StripeCoupon): number | undefined {
    if (
      !this.propertyPrice ||
      !coupon ||
      (coupon.appliesTo &&
        !coupon.appliesTo.products.some(
          (productId: string) =>
            productId === this.propertyStripeId || productId === this.propertyStripeUsId
        ))
    ) {
      return this.propertyPrice;
    }

    return this.propertyPrice - coupon.getValueOfDiscount(this.propertyPrice);
  }
}
